/* Browser Check */
function addBrowserClass() {
  const body = document.body;
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.indexOf('chrome') > -1 && userAgent.indexOf('edge') === -1) {
    body.classList.add('browser-chrome');
  } else if (userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1) {
    body.classList.add('browser-safari');
  } else if (userAgent.indexOf('firefox') > -1) {
    body.classList.add('browser-firefox');
  } else if (userAgent.indexOf('edge') > -1) {
    body.classList.add('browser-edge');
  } else {
    body.classList.add('browser-unknown');
  }
}

addBrowserClass();

document.addEventListener('DOMContentLoaded', () => {
  const TAB_ROOT_SELECTOR = '.tabs-dynamic';

  document.querySelectorAll(TAB_ROOT_SELECTOR).forEach((root, i) => {
    const list = root.querySelector('.tabs__list');
    if (!list) return;

    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const underline = root.querySelector('.tabs__underline');

    // Prefer panels inside the next sibling .tabs__panels (if present)
    const siblingPanelsWrap =
      root.nextElementSibling && root.nextElementSibling.classList &&
      root.nextElementSibling.classList.contains('tabs__panels')
        ? root.nextElementSibling
        : null;

    // Build a mapping from each tab -> its panel (scoped if possible)
    const panelByTab = new Map();
    tabs.forEach(tab => {
      const panelId = tab.getAttribute('aria-controls');
      let panel = null;

      if (siblingPanelsWrap) {
        panel = siblingPanelsWrap.querySelector('#' + CSS.escape(panelId));
        if (!panel) {
          // fallback: look by aria-labelledby inside the sibling wrap
          panel = siblingPanelsWrap.querySelector(
            `[role="tabpanel"][aria-labelledby="${CSS.escape(tab.id)}"]`
          );
        }
      }

      // Final fallback: global lookup (works if IDs are unique)
      if (!panel && panelId) {
        panel = document.getElementById(panelId);
      }

      if (panel) panelByTab.set(tab, panel);
    });

    function setActive(tab) {
      tabs.forEach(t => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;

        const panel = panelByTab.get(t);
        if (panel) panel.setAttribute('aria-hidden', String(!on));
      });

      // underline movement (only if underline exists)
      if (underline) {
        const rect = tab.getBoundingClientRect();
        const listRect = list.getBoundingClientRect();
        underline.style.width = rect.width + 'px';
        underline.style.transform =
          `translateX(${rect.left - listRect.left + list.scrollLeft}px)`;
      }

      // ensure active tab is visible when scrolled
      const buffer = 24;
      const left = tab.offsetLeft - buffer;
      const right = left + tab.offsetWidth + buffer * 2;
      if (left < list.scrollLeft) list.scrollLeft = left;
      else if (right > list.scrollLeft + list.clientWidth) {
        list.scrollLeft = right - list.clientWidth;
      }
    }

    // Click handler (scoped)
    list.addEventListener('click', e => {
      const btn = e.target.closest('[role="tab"]');
      if (!btn || !list.contains(btn)) return;
      setActive(btn);
      btn.focus();
    });

    // Keyboard handler (scoped)
    list.addEventListener('keydown', e => {
      const current = document.activeElement.closest('[role="tab"]');
      if (!current || !list.contains(current)) return;

      let idx = tabs.indexOf(current);
      if (e.key === 'ArrowRight') { idx = (idx + 1) % tabs.length; e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { idx = (idx - 1 + tabs.length) % tabs.length; e.preventDefault(); }
      else if (e.key === 'Home') { idx = 0; e.preventDefault(); }
      else if (e.key === 'End') { idx = tabs.length - 1; e.preventDefault(); }
      else return;

      setActive(tabs[idx]);
      tabs[idx].focus();
    });

    // Init (scoped)
    const init = () => {
      const start = tabs.find(t => t.getAttribute('aria-selected') === 'true') || tabs[0];
      if (start) setActive(start);
    };

    // Keep underline aligned on resize
    window.addEventListener('resize', () => {
      const active = tabs.find(t => t.getAttribute('aria-selected') === 'true');
      if (active) setActive(active);
    });

    init();
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const flagEls = document.querySelectorAll('.country-flag');
  if (!flagEls.length) return;

  const countries = {
    "australia": "AU",
    "austria": "AT",
    "belgium": "BE",
    "bulgaria": "BG",
    "canada": "CA",
    "croatia": "HR",
    "cyprus": "CY",
    "czechia": "CZ",
    "denmark": "DK",
    "estonia": "EE",
    "finland": "FI",
    "france": "FR",
    "germany": "DE",
    "greece": "GR",
    "hong kong": "HK",
    "hungary": "HU",
    "ireland": "IE",
    "israel": "IL",
    "italy": "IT",
    "japan": "JP",
    "latvia": "LV",
    "lithuania": "LT",
    "luxembourg": "LU",
    "malaysia": "MY",
    "malta": "MT",
    "netherlands": "NL",
    "new zealand": "NZ",
    "norway": "NO",
    "poland": "PL",
    "portugal": "PT",
    "romania": "RO",
    "singapore": "SG",
    "slovakia": "SK",
    "slovenia": "SI",
    "south korea": "KR",
    "spain": "ES",
    "sweden": "SE",
    "switzerland": "CH",
    "united arab emirates": "AE",
    "united kingdom": "GB",
    "united states": "US",
    "thailand": "TH",
    'south africa': "ZA",
    'switerland': 'CH',
    'north macedonia': 'MK',
    'uk': "GB",
    'usa': "US"
  };

  flagEls.forEach(el => {
    const text = (el.dataset.title || '').toLowerCase();
    for (const [name, code] of Object.entries(countries)) {
      if (text.includes(name)) {
        el.classList.add(`country-flags--${code}`);
        break;
      }
    }
  });
});


document.addEventListener("DOMContentLoaded", function() {
  const triggerTab = document.querySelector('.cvv-author-social-btn .btn.btn-layout1'); // change this to your specific button
  const faqTab = document.querySelector('#tab-faq');
  const faqPanel = document.querySelector('#panel-faq');

  if (triggerTab && faqTab && faqPanel) {
    triggerTab.addEventListener('click', () => {
      // Trigger the FAQ tab click
      faqTab.click();

      // Scroll down after a short delay (so the content can appear)
      setTimeout(() => {
        faqPanel.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 300); // Adjust delay if needed (e.g. 500ms)
    });
  }
});

// Handle every wrapper on the page (safe + reusable)
document.querySelectorAll('.product-description-wrapper').forEach(function (wrap) {
  const desc = wrap.querySelector('.product-info__description');
  const btn  = wrap.querySelector('.read-more-btn');
  if (!desc || !btn) return;

  const text = desc.innerText.trim().replace(/\s+/g, ' ');
  const wordCount = text ? text.split(' ').length : 0;

  if (wordCount > 32) {
    btn.style.display = 'inline-block';
    desc.classList.add('short');
    btn.textContent = 'Read more';
  } else {
    btn.style.display = 'none';
    desc.classList.remove('short');
  }

  // Smooth expand/collapse toggle
  btn.addEventListener('click', function () {
    const isShort = desc.classList.contains('short');

    if (isShort) {
      // Expand smoothly
      desc.style.maxHeight = desc.scrollHeight + 'px';
      setTimeout(() => desc.classList.remove('short'), 500);
      btn.textContent = 'Read less';
    } else {
      // Collapse smoothly
      desc.style.maxHeight = desc.scrollHeight + 'px';
      setTimeout(() => {
        desc.classList.add('short');
        desc.style.maxHeight = '180px';
      }, 10);
      btn.textContent = 'Read more';
    }
  });
});

// Rich text readmore/readless (Mobile only)
function initRichTextReadMore() {
  // Only run on mobile
  if (window.innerWidth > 820) {
    // On desktop, ensure all content is expanded
    document.querySelectorAll('.rich-text-content').forEach(function(content) {
      content.classList.remove('short');
    });
    return;
  }

  document.querySelectorAll('.rich-text-readmore-wrapper').forEach(function (wrap) {
    const content = wrap.querySelector('.rich-text-content');
    const btn = wrap.querySelector('.rich-text-readmore-btn');
    if (!content || !btn) return;

    // Check if this wrapper has already been initialized
    // If it has a data-initialized attribute, preserve the user's state
    const isInitialized = wrap.hasAttribute('data-initialized');
    const wasExpanded = wrap.hasAttribute('data-expanded');

    // Check if content is long enough to need readmore
    const text = content.innerText.trim().replace(/\s+/g, ' ');
    const wordCount = text ? text.split(' ').length : 0;
    const contentHeight = content.scrollHeight;
    const maxHeight = 180; // Match CSS max-height

    if (contentHeight > maxHeight || wordCount > 32) {
      btn.style.display = 'inline-block';
      
      // Only reset to 'short' if this is the first initialization
      // If already initialized, preserve the user's expanded state
      if (!isInitialized) {
        content.classList.add('short');
        btn.textContent = 'Read more';
        wrap.setAttribute('data-initialized', 'true');
        wrap.removeAttribute('data-expanded');
      } else if (wasExpanded) {
        // User had expanded it, keep it expanded
        content.classList.remove('short');
        btn.textContent = 'Read less';
      } else {
        // User had it collapsed, keep it collapsed
        content.classList.add('short');
        btn.textContent = 'Read more';
      }
    } else {
      btn.style.display = 'none';
      content.classList.remove('short');
      wrap.setAttribute('data-initialized', 'true');
    }

    // Only add event listener if not already added
    if (!btn.hasAttribute('data-listener-added')) {
      btn.setAttribute('data-listener-added', 'true');
      
      // Smooth expand/collapse toggle
      btn.addEventListener('click', function () {
        const isShort = content.classList.contains('short');

        if (isShort) {
          // Expand smoothly
          content.style.maxHeight = content.scrollHeight + 'px';
          setTimeout(() => {
            content.classList.remove('short');
            content.style.maxHeight = '';
          }, 500);
          btn.textContent = 'Read less';
          wrap.setAttribute('data-expanded', 'true');
        } else {
          // Collapse smoothly
          content.style.maxHeight = content.scrollHeight + 'px';
          setTimeout(() => {
            content.classList.add('short');
            content.style.maxHeight = '180px';
          }, 10);
          btn.textContent = 'Read more';
          wrap.removeAttribute('data-expanded');
        }
      });
    }
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initRichTextReadMore);

// Re-initialize on window resize (for responsive behavior)
let resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(initRichTextReadMore, 250);
});

// size modal
document.addEventListener('DOMContentLoaded', () => {
  const openButtons = document.querySelectorAll('[data-modal-target]');
  const body = document.body;

  const openModal = (modal) => {
    if (!modal) return;
    modal.classList.add('is-open');
    body.classList.add('no-scroll');
  };

  const closeModal = (modal) => {
    if (!modal) return;
    modal.classList.remove('is-open');
    body.classList.remove('no-scroll');
  };

  // Open buttons
  openButtons.forEach(btn => {
    const targetSelector = btn.getAttribute('data-modal-target');
    const modal = document.querySelector(targetSelector);

    if (!modal) return;

    btn.addEventListener('click', () => openModal(modal));

    // Close via close button(s)
  const closeBtns = modal.querySelectorAll('.modal__close, .modal__cancel');
  closeBtns.forEach(closeBtn =>
    closeBtn.addEventListener('click', () => closeModal(modal))
  );

    // Close via overlay
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal(modal);
    });

    // Prevent inner clicks from bubbling
    modal.querySelector('.modal__panel')?.addEventListener('click', e => e.stopPropagation());
  });

  // Close any open modal via ESC
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.modal.is-open').forEach(modal => closeModal(modal));
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.toggle-password');

  toggles.forEach(function (toggleBtn) {
    const passwordInput = toggleBtn.closest('.password-field').querySelector('input[type="password"], input[type="text"]');
    const eye = toggleBtn.querySelector('.icon-eye');
    const eyeOff = toggleBtn.querySelector('.icon-eye-off');

    toggleBtn.addEventListener('click', function () {
      const isHidden = passwordInput.getAttribute('type') === 'password';
      passwordInput.setAttribute('type', isHidden ? 'text' : 'password');
      eye.style.display = isHidden ? 'none' : 'block';
      eyeOff.style.display = isHidden ? 'block' : 'none';
      toggleBtn.setAttribute('aria-label', isHidden ? 'Hide password' : 'Show password');
    });
  });

  // product page
  // const buttons = document.querySelectorAll('.block-swatch');

  // buttons.forEach(btn => {
  //   btn.addEventListener('click', function() {
  //     buttons.forEach(b => b.classList.remove('active')); // remove from all
  //     this.classList.add('active'); // add to clicked one
  //     document.querySelectorAll('.buy-buttons').forEach(btn => {
  //       btn.classList.add('active');
  //     });
  //   });
  // });

});

  document.addEventListener("DOMContentLoaded", function() {
  const params = new URLSearchParams(window.location.search);
  const targetCreators = params.get("cat_creators");
  const targetSneakers = params.get("cat_sneakers");
  const targetValue = targetCreators || targetSneakers;
  if (!targetValue) return;
  window.addEventListener("load", function() {
    const buttons = document.querySelectorAll("div#productTabs .tabs__list-wrap .tabs__list button");
    buttons.forEach(button => {
      const buttonText = button.textContent.trim().toLowerCase();
      if (buttonText === targetValue.trim().toLowerCase()) {
        button.click();
      }
    });
  });
});

document.querySelectorAll('.variant-picker__option').forEach(fs => {
  let interacted = false;

  fs.addEventListener('click', (e) => {
    const swatch = e.target.closest('label.block-swatch');
    if (!swatch) return;

    // mark this group as interacted (used by CSS to stop default :checked styling)
    if (!interacted) {
      fs.classList.add('is-interacted');
      interacted = true;
    }

    // keep active scoped to THIS option group
    fs.querySelectorAll('label.block-swatch.active')
      .forEach(el => el.classList.remove('active'));

    swatch.classList.add('active');

    // ✅ update the visible variant-option-value text
    const variantValue = swatch.textContent.trim(); // e.g. "UK 3"
    const output = fs.querySelector('variant-option-value');
    if (output) {
      output.textContent = variantValue;
    }

    // keep your existing buy button logic
    document.querySelectorAll('.buy-buttons').forEach(btn => {
      btn.classList.add('active');
    });

    // sync radio
    const id = swatch.getAttribute('for');
    const input = id && document.getElementById(id);
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Ensure ATC label resets on size selection (scoped to the same product form)
    // Defer to let any other change handlers run first
    setTimeout(() => {
      const picker = fs.closest('variant-picker');
      const formId = picker ? picker.getAttribute('form') : null;
      if (!formId) return;

      const buyButtonsList = document.querySelectorAll(`buy-buttons[form="${CSS.escape(formId)}"]`);
      buyButtonsList.forEach(buyButtons => {
        const atcBtn = buyButtons.querySelector('button.button');
        if (atcBtn) {
          atcBtn.disabled = false;
          //atcBtn.textContent = 'Add to Cart';
        }
      });
    }, 0);
  });
});

// Disable ATC until a size is selected (per product form)
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('variant-picker').forEach(picker => {
    const formId = picker.getAttribute('form');
    if (!formId) return;

    const buyButtonsList = document.querySelectorAll(`buy-buttons[form="${CSS.escape(formId)}"]`);
    buyButtonsList.forEach(buyButtons => {
      const atcBtn = buyButtons.querySelector('button.button');
      if (atcBtn) {
        atcBtn.disabled = true;
      }
    });
  });
});

// search filter

document.addEventListener('DOMContentLoaded', () => {
  const host = document.querySelector('.new-header-search');
  if (!host) return;

  const ps = host.querySelector('predictive-search');
  if (!ps) return;

  let mo, debounceId;

  function applyVisibility() {
    // Active top pill inside the header (Creators / Sneakers)
    const activeBtn = host.querySelector('.btn-search[aria-selected="true"]');
    if (!activeBtn) return;

    const btnText = activeBtn.textContent.trim().toLowerCase();

    // Scope to THIS predictive-search instance
    const titles = ps.querySelectorAll('.predictive-search__tab-item[slot="title"]');
    const panels = ps.querySelectorAll('.predictive-search__tab-content[slot="content"]');

    // Hide all first
    titles.forEach(t => (t.style.display = 'none'));
    panels.forEach(p => (p.style.display = 'none'));

    // Show the one whose data-id matches the active pill text
    const matchTitle = Array.from(titles).find(t => (t.dataset.id || '').trim().toLowerCase() === btnText);
    const matchPanel = ps.querySelector(`.predictive-search__tab-content[slot="content"][data-id="${btnText}"]`);

    if (matchTitle) matchTitle.style.display = '';
    if (matchPanel)  matchPanel.style.display  = '';

    // If the x-tabs button isn’t selected yet, select it
    const tabBtn = matchTitle?.querySelector('button, a');
    if (tabBtn && tabBtn.getAttribute('aria-selected') !== 'true') {
      tabBtn.click();
    }
  }

  function applySafely() {
    // Avoid re-triggering ourselves while mutating
    mo?.disconnect();
    try {
      applyVisibility();
    } finally {
      startObserving();
    }
  }

  function debouncedApply() {
    clearTimeout(debounceId);
    // Small delay + rAF to run after theme injects/updates DOM
    debounceId = setTimeout(() => requestAnimationFrame(applySafely), 50);
  }

  function startObserving() {
    if (mo) mo.disconnect();
    mo = new MutationObserver(debouncedApply);
    mo.observe(ps, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-selected'] // catch tab changes without child swaps
    });
  }

  // Clicks on header pills or on predictive-search tabs
  host.addEventListener('click', (e) => {
    if (e.target.closest('.btn-search') || e.target.closest('.predictive-search__tab-item[slot="title"] button')) {
      debouncedApply();
    }
  });

  // Initial pass
  debouncedApply();
});